import { ICreateAndUpdateMunicipality } from "../../../types/common.interface";
import { ICreateAndUpdateSuperAgent } from "../../../types/superAgent.interface";
import customAxios from "../../customAxios";
import { MUNICYPULITY_UPDATE, UPDATE_SUPER_AGENT } from "../../routes";

const updateMunicipality = async (formData: ICreateAndUpdateMunicipality) => {
  try {
    return (
      await customAxios.put(MUNICYPULITY_UPDATE + `/${formData._id}`, {
        ...formData,
        city: formData.city?._id,
        province: formData.province?._id,
        financialGroupSchool: formData.financialGroupSchool?._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_SUPER_AGENT: error });
    return false;
  }
};

export default updateMunicipality;
